<template>
  <tr :class="liveMeeting() ? 'table-danger' : ''" class="meeting">
    <td class="text-start">
      <div v-if="meeting.occurrence_id">
        <router-link :to="viewUrl + '?occurrence=' + meeting.occurrence_id">
          <strong>{{ meeting.title }}</strong>
        </router-link>
      </div>
      <div v-else>
        <router-link :to="viewUrl">
          <strong>{{ meeting.title }}</strong>
        </router-link>
      </div>
    </td>
    <td style="color: #4a4b65 !important;">
      <strong>
        {{ utcToLocal(meeting.start).format('MMM D, YYYY') }}
        -
        {{ utcToLocal(meeting.start).format('hh:mm A') }}
      </strong>
      <strong v-if="liveMeeting()" class="text-danger"><br />{{ $t('meeting.happening-now') }}</strong>
    </td>
    <td>
      <span style="color: #005f9a; font-size: 1rem; cursor: pointer;">
        <strong v-if="meeting.occurrences && meeting.occurrences.length != 0">
          <div v-for="(value, index) in sortedArray(meeting.occurrences, 'asc')" :key="index">
            <div v-if="meeting.start == value.start">
              <div v-if="currentMeetingView == 'upcoming'">
                <span @click="showOccurrences = !showOccurrences">{{ index+1 }} of {{ meeting.occurrences.length }}</span>
              </div>
              <div v-else>
                <span v-if="index+1 === meeting.occurrences.length && !meeting.auto_extend" class="text-danger fw-bold" @click="extendMeeting()">
                  {{ $t('extend') }}
                </span>
                <span v-else @click="showOccurrences = !showOccurrences">{{ index+1 }} of {{ meeting.occurrences.length }}</span>
              </div>
            </div>
          </div>
        </strong>
        <strong v-else>N/A</strong>
      </span>
    </td>
    <td v-if="currentMeetingView == 'upcoming'">
      <div v-if="meeting.occurrence_id">
          <button id="add_to_calendar" v-b-modal="'calendarLinks'" data-test="add_to_calendar" class="btn btn-primary btn-sm pe-4 ps-4" @click="sendInfo(meeting.occurrence_id, 'calendar');">
            {{ $t('add-to-calendar') }}
          </button>
      </div>
      <div v-else>
        <button id="add_to_calendar" data-test="add_to_calendar" class="btn btn-primary btn-sm pe-4 ps-4" @click="showCalendarLinks = !showCalendarLinks">
          {{ $t('add-to-calendar') }}
        </button>
      </div>
    </td>
    <td v-if="currentMeetingView == 'past'">
      <div v-if="meeting.occurrence_id">
        <a :href="'/networks/' + network.slug + '/meetings/report/' + this.meeting.id + '?occurrence=' + meeting.occurrence_id"
        class="btn btn-primary btn-sm pe-4 ps-4" target="_blank">
          {{ $t('meeting.view-report') }}
        </a>
      </div>
      <div v-else>
        <a :href="'/networks/' + network.slug + '/meetings/report/' + this.meeting.id"
        class="btn btn-primary btn-sm pe-4 ps-4" target="_blank">
          {{ $t('meeting.view-report') }}
        </a>
      </div>
    </td>
    <td v-if="currentMeetingView == 'upcoming'">
      <div v-if="meeting.occurrence_id">
          <button id="share_link" v-b-modal="'shareOccurrences'" data-test="share_link" class="btn btn-outline-primary btn-sm pe-4 ps-4 custom-border"
          @click="sendInfo(meeting.occurrence_id, 'occurrence');">
              {{ $t('meeting.share-link') }}
          </button>
      </div>
      <div v-else>
        <button id="share_link" data-test="share_link" class="btn btn-outline-primary btn-sm pe-4 ps-4 custom-border"
        @click="showShareLinks = !showShareLinks">
          {{ $t('meeting.share-link') }}
        </button>
      </div>
    </td>
    <!-- Modals -->
    <b-modal v-model="showOccurrences" hide-footer hide-header no-stacking>
      <div v-if="meeting.occurrences != ''">
        <div class="text-center">
          <div style="width: 250px; float: left; text-align: center; margin-top: 6px; color: crimson;">
            <strong>{{ $t('meeting.main-meeting') }}</strong>
          </div>
          <a :href="viewUrl" target="_blank" class="ms-3">
            <button id="view" data-test="view" class="btn btn-sm btn-primary">
              {{ $t('network.view') }}
            </button>
          </a>
          <button id="share_link" data-test="share_link" class="btn btn-sm btn-outline-primary ms-2 custom-border"
          @click="showShareLinks = !showShareLinks">
            {{ $t('meeting.share-link') }}
          </button>
        </div><hr />
        <div v-for="value in sortedArray(meeting.occurrences, 'asc')" :key="value.name" class="text-center">
          <div v-if="currentMeetingView == 'upcoming' && (utcToLocal(value.start).format() >= today)">
            <div style="width: 250px; float: left; text-align: right; margin-top: 6px;">
              <strong>{{ utcToLocal(value.start).format('MMMM DD, YYYY') }} -
              {{ utcToLocal(value.start).format('hh:mm A') }}</strong>
            </div>
            <a :href="viewUrl + '?occurrence=' + value.occurrence_id" target="_blank" class="ms-3">
              <button id="view" data-test="view" class="btn btn-sm btn-primary">
                {{ $t('network.view') }}
              </button>
            </a>
            <button id="share_link" v-b-modal="'shareOccurrences'" data-test="share_link" class="btn btn-sm btn-outline-primary ms-2 custom-border"
            @click="sendInfo(value.occurrence_id, 'occurrence');">
            {{ $t('meeting.share-link') }}
            </button>
            <hr />
          </div>
          <div v-if="currentMeetingView == 'past' && (utcToLocal(value.start).format() < today)">
            <div style="width: 250px; float: left; text-align: right; margin-top: 6px;">
              <strong>{{ utcToLocal(value.start).format('MMMM DD, YYYY') }} -
              {{ utcToLocal(value.start).format('hh:mm A') }}</strong>
            </div>
            <a :href="viewUrl + '?occurrence=' + value.occurrence_id" target="_blank" class="ms-3">
              <button id="view" data-test="view" class="btn btn-sm btn-primary">
                {{ $t('network.view') }}
              </button>
            </a>
            <button id="share_link" v-b-modal="'shareOccurrences'" data-test="share_link" class="btn btn-sm btn-outline-primary ms-2 custom-border"
            @click="sendInfo(value.occurrence_id, 'occurrence');">
            {{ $t('meeting.share-link') }}
            </button>
            <hr />
          </div>
        </div>
        <div class="text-center text-info">
          <small v-if="meeting.auto_extend">
            Meeting will be automatically extended after the last occurrence.<br>
            You can change this setting by editing the main meeting.
          </small>
          <small v-else>
            Meeting will end after the last occurrence unless extended manually.<br>
            You can set it up for automatic extension by editing the main meeting.
          </small>
        </div>
      </div>
      <div v-else class="text-center">
        {{ $t('meeting.there-are-no-occurrences-for-this-meeting') }}
      </div>
    </b-modal>
    <b-modal :id="'shareOccurrences' + null" v-model="showShareOccurrenceLinks" hide-footer hide-header no-stacking>
      <div class="text-center">
        <span v-html="$t('share-this-meeting-info-and-link-to-your-choice-of-social-media-or-contacts', { networkShortName: network.short_name })"></span><br /><br />
        <a class="pointer" @click="accessShareLink('Facebook', facebook+home+viewUrl+occurrence)">
          <svg id="Layer_1" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
          width="45" height="45" viewBox="0 0 418.135 418.135" style="enable-background:new 0 0 418.135 418.135; margin-right: 20px;" xml:space="preserve">
            <path style="fill:#475993;" d="M353.701,0H55.087C24.665,0,0.002,24.662,0.002,55.085v298.616c0,30.423,24.662,55.085,55.085,55.085
            h147.275l0.251-146.078h-37.951c-4.932,0-8.935-3.988-8.954-8.92l-0.182-47.087c-0.019-4.959,3.996-8.989,8.955-8.989h37.882
            v-45.498c0-52.8,32.247-81.55,79.348-81.55h38.65c4.945,0,8.955,4.009,8.955,8.955v39.704c0,4.944-4.007,8.952-8.95,8.955
            l-23.719,0.011c-25.615,0-30.575,12.172-30.575,30.035v39.389h56.285c5.363,0,9.524,4.683,8.892,10.009l-5.581,47.087
            c-0.534,4.506-4.355,7.901-8.892,7.901h-50.453l-0.251,146.078h87.631c30.422,0,55.084-24.662,55.084-55.084V55.085
            C408.786,24.662,384.124,0,353.701,0z"/>
          </svg>
        </a>
        <a class="pointer" @click="accessShareLink('WhatsApp', whatsapp+home+viewUrl+occurrence)">
          <svg id="Layer_1" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
          width="45" height="45" viewBox="0 0 418.135 418.135" style="enable-background:new 0 0 418.135 418.135; margin-right: 20px;" xml:space="preserve">
            <path style="fill:#7AD06D;" d="M198.929,0.242C88.5,5.5,1.356,97.466,1.691,208.02c0.102,33.672,8.231,65.454,22.571,93.536
              L2.245,408.429c-1.191,5.781,4.023,10.843,9.766,9.483l104.723-24.811c26.905,13.402,57.125,21.143,89.108,21.631
              c112.869,1.724,206.982-87.897,210.5-200.724C420.113,93.065,320.295-5.538,198.929,0.242z M323.886,322.197
              c-30.669,30.669-71.446,47.559-114.818,47.559c-25.396,0-49.71-5.698-72.269-16.935l-14.584-7.265l-64.206,15.212l13.515-65.607
              l-7.185-14.07c-11.711-22.935-17.649-47.736-17.649-73.713c0-43.373,16.89-84.149,47.559-114.819
              c30.395-30.395,71.837-47.56,114.822-47.56C252.443,45,293.218,61.89,323.887,92.558c30.669,30.669,47.559,71.445,47.56,114.817
              C371.446,250.361,354.281,291.803,323.886,322.197z"/>
            <path style="fill:#7AD06D;" d="M309.712,252.351l-40.169-11.534c-5.281-1.516-10.968-0.018-14.816,3.903l-9.823,10.008
              c-4.142,4.22-10.427,5.576-15.909,3.358c-19.002-7.69-58.974-43.23-69.182-61.007c-2.945-5.128-2.458-11.539,1.158-16.218
              l8.576-11.095c3.36-4.347,4.069-10.185,1.847-15.21l-16.9-38.223c-4.048-9.155-15.747-11.82-23.39-5.356
              c-11.211,9.482-24.513,23.891-26.13,39.854c-2.851,28.144,9.219,63.622,54.862,106.222c52.73,49.215,94.956,55.717,122.449,49.057
              c15.594-3.777,28.056-18.919,35.921-31.317C323.568,266.34,319.334,255.114,309.712,252.351z"/>
          </svg>
        </a>
        <a class="pointer" @click="accessShareLink('LinkedIn', linkedin+home+viewUrl+occurrence)">
          <svg id="Layer_1" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
          width="45" height="45" viewBox="0 0 418.135 418.135" style="enable-background:new 0 0 418.135 418.135; margin-right: 10px;" xml:space="preserve">
            <path style="fill:#0077B7;" d="M347.445,0H34.555C15.471,0,0,15.471,0,34.555v312.889C0,366.529,15.471,382,34.555,382h312.889
            C366.529,382,382,366.529,382,347.444V34.555C382,15.471,366.529,0,347.445,0z M118.207,329.844c0,5.554-4.502,10.056-10.056,10.056
            H65.345c-5.554,0-10.056-4.502-10.056-10.056V150.403c0-5.554,4.502-10.056,10.056-10.056h42.806
            c5.554,0,10.056,4.502,10.056,10.056V329.844z M86.748,123.432c-22.459,0-40.666-18.207-40.666-40.666S64.289,42.1,86.748,42.1
            s40.666,18.207,40.666,40.666S109.208,123.432,86.748,123.432z M341.91,330.654c0,5.106-4.14,9.246-9.246,9.246H286.73
            c-5.106,0-9.246-4.14-9.246-9.246v-84.168c0-12.556,3.683-55.021-32.813-55.021c-28.309,0-34.051,29.066-35.204,42.11v97.079
            c0,5.106-4.139,9.246-9.246,9.246h-44.426c-5.106,0-9.246-4.14-9.246-9.246V149.593c0-5.106,4.14-9.246,9.246-9.246h44.426
            c5.106,0,9.246,4.14,9.246,9.246v15.655c10.497-15.753,26.097-27.912,59.312-27.912c73.552,0,73.131,68.716,73.131,106.472
            L341.91,330.654L341.91,330.654z"/>
          </svg>
        </a>
        <a class="pointer" @click="accessShareLink('Twitter', twitter+home+viewUrl+occurrence)">
          <svg id="Layer_1" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
          width="55" height="55" viewBox="0 0 1668.56 1221.19" style="enable-background:new 0 0 1668.56 1221.19; margin-right: 10px;" xml:space="preserve">
          <g id="layer1" transform="translate(52.390088,-25.058597)">
            <path id="path1009" d="M283.94,167.31l386.39,516.64L281.5,1104h87.51l340.42-367.76L984.48,1104h297.8L874.15,558.3l361.92-390.99
              h-87.51l-313.51,338.7l-253.31-338.7H283.94z M412.63,231.77h136.81l604.13,807.76h-136.81L412.63,231.77z"/>
          </g>
          </svg>
        </a>
        <a class="pointer" @click="accessShareLink('Email', email+home+viewUrl+occurrence)">
          <svg id="Layer_1" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
          width="45" height="45" viewBox="0 0 128 128" style="enable-background:new 0 0 128 128;" xml:space="preserve">
            <circle style="fill:#267CB5;" cx="64" cy="64" r="64"/>
            <path style="fill:#FFFFFF;" d="M64,28"/>
            <path style="fill:#FFFFFF;" d="M64,72.4l38.2-32.7c-0.6-0.4-1.4-0.7-2.2-0.7H28c-0.8,0-1.6,0.3-2.2,0.7L64,72.4z"/>
            <path style="fill:#FFFFFF;" d="M66.6,75.4c-1.5,1.3-3.7,1.3-5.2,0L24,43.5V85c0,2.2,1.8,4,4,4h72c2.2,0,4-1.8,4-4V43.4L66.6,75.4z"/>
          </svg>
        </a>
      </div>
      <div class="form-control align-items-center sharing">
        <span class="url-field">{{ home + '/...' }}</span>
        <div style="float: right;">
          <span class="btn btn-primary btn-sm text-white copy-btn" @click.prevent="copyUrl('url1')">
            <span>{{ $t('Invite.copy').toUpperCase() }}</span>
          </span>
        </div>
        <input id="url1" data-test="url1" :value="home+viewUrl+occurrence" type="hidden">
      </div>
      <span id="copied1" style="display: none;">{{ $t('Invite.copied') }}</span>
      <div v-if="$auth.auth && $auth.hasRole('super-admin')" class="mt-3">
        <span class="text-danger fw-semibold">Direct zoom link. Using this won't capture attendance.</span>
        <div class="form-control align-items-center zoom-sharing">
          <span class="url-field">https://resonancehealth-org.zoom.us/...</span>
          <div style="float: right;">
            <span class="btn btn-primary btn-sm text-white copy-btn" @click.prevent="copyUrl('zoom')">
              <span>{{ $t('Invite.copy').toUpperCase() }}</span>
            </span>
          </div>
          <input id="zoom_url" data-test="zoom_url" :value="meeting.zoom_meeting.url" type="hidden">
        </div>
        <span v-if="$auth.auth && $auth.hasRole('super-admin')" id="zoom_copied" style="display: none;">{{ $t('Invite.copied') }}</span>
      </div>
    </b-modal>
    <b-modal v-model="showShareLinks" hide-footer hide-header no-stacking>
      <div class="text-center">
        <span v-html="$t('share-this-meeting-info-and-link-to-your-choice-of-social-media-or-contacts', { networkShortName: network.short_name })"></span><br /><br />
        <a @click="accessShareLink('Facebook', facebook+home+viewUrl)">
          <svg id="Layer_1" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
          width="45" height="45" viewBox="0 0 418.135 418.135" style="enable-background:new 0 0 418.135 418.135; margin-right: 20px;" xml:space="preserve">
            <path style="fill:#475993;" d="M353.701,0H55.087C24.665,0,0.002,24.662,0.002,55.085v298.616c0,30.423,24.662,55.085,55.085,55.085
            h147.275l0.251-146.078h-37.951c-4.932,0-8.935-3.988-8.954-8.92l-0.182-47.087c-0.019-4.959,3.996-8.989,8.955-8.989h37.882
            v-45.498c0-52.8,32.247-81.55,79.348-81.55h38.65c4.945,0,8.955,4.009,8.955,8.955v39.704c0,4.944-4.007,8.952-8.95,8.955
            l-23.719,0.011c-25.615,0-30.575,12.172-30.575,30.035v39.389h56.285c5.363,0,9.524,4.683,8.892,10.009l-5.581,47.087
            c-0.534,4.506-4.355,7.901-8.892,7.901h-50.453l-0.251,146.078h87.631c30.422,0,55.084-24.662,55.084-55.084V55.085
            C408.786,24.662,384.124,0,353.701,0z"/>
          </svg>
        </a>
        <a @click="accessShareLink('WhatsApp', whatsapp+home+viewUrl)">
          <svg id="Layer_1" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
          width="45" height="45" viewBox="0 0 418.135 418.135" style="enable-background:new 0 0 418.135 418.135; margin-right: 20px;" xml:space="preserve">
            <path style="fill:#7AD06D;" d="M198.929,0.242C88.5,5.5,1.356,97.466,1.691,208.02c0.102,33.672,8.231,65.454,22.571,93.536
              L2.245,408.429c-1.191,5.781,4.023,10.843,9.766,9.483l104.723-24.811c26.905,13.402,57.125,21.143,89.108,21.631
              c112.869,1.724,206.982-87.897,210.5-200.724C420.113,93.065,320.295-5.538,198.929,0.242z M323.886,322.197
              c-30.669,30.669-71.446,47.559-114.818,47.559c-25.396,0-49.71-5.698-72.269-16.935l-14.584-7.265l-64.206,15.212l13.515-65.607
              l-7.185-14.07c-11.711-22.935-17.649-47.736-17.649-73.713c0-43.373,16.89-84.149,47.559-114.819
              c30.395-30.395,71.837-47.56,114.822-47.56C252.443,45,293.218,61.89,323.887,92.558c30.669,30.669,47.559,71.445,47.56,114.817
              C371.446,250.361,354.281,291.803,323.886,322.197z"/>
            <path style="fill:#7AD06D;" d="M309.712,252.351l-40.169-11.534c-5.281-1.516-10.968-0.018-14.816,3.903l-9.823,10.008
              c-4.142,4.22-10.427,5.576-15.909,3.358c-19.002-7.69-58.974-43.23-69.182-61.007c-2.945-5.128-2.458-11.539,1.158-16.218
              l8.576-11.095c3.36-4.347,4.069-10.185,1.847-15.21l-16.9-38.223c-4.048-9.155-15.747-11.82-23.39-5.356
              c-11.211,9.482-24.513,23.891-26.13,39.854c-2.851,28.144,9.219,63.622,54.862,106.222c52.73,49.215,94.956,55.717,122.449,49.057
              c15.594-3.777,28.056-18.919,35.921-31.317C323.568,266.34,319.334,255.114,309.712,252.351z"/>
          </svg>
        </a>
        <a @click="accessShareLink('LinkedIn', linkedin+home+viewUrl)">
          <svg id="Layer_1" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
          width="45" height="45" viewBox="0 0 418.135 418.135" style="enable-background:new 0 0 418.135 418.135; margin-right: 10px;" xml:space="preserve">
            <path style="fill:#0077B7;" d="M347.445,0H34.555C15.471,0,0,15.471,0,34.555v312.889C0,366.529,15.471,382,34.555,382h312.889
            C366.529,382,382,366.529,382,347.444V34.555C382,15.471,366.529,0,347.445,0z M118.207,329.844c0,5.554-4.502,10.056-10.056,10.056
            H65.345c-5.554,0-10.056-4.502-10.056-10.056V150.403c0-5.554,4.502-10.056,10.056-10.056h42.806
            c5.554,0,10.056,4.502,10.056,10.056V329.844z M86.748,123.432c-22.459,0-40.666-18.207-40.666-40.666S64.289,42.1,86.748,42.1
            s40.666,18.207,40.666,40.666S109.208,123.432,86.748,123.432z M341.91,330.654c0,5.106-4.14,9.246-9.246,9.246H286.73
            c-5.106,0-9.246-4.14-9.246-9.246v-84.168c0-12.556,3.683-55.021-32.813-55.021c-28.309,0-34.051,29.066-35.204,42.11v97.079
            c0,5.106-4.139,9.246-9.246,9.246h-44.426c-5.106,0-9.246-4.14-9.246-9.246V149.593c0-5.106,4.14-9.246,9.246-9.246h44.426
            c5.106,0,9.246,4.14,9.246,9.246v15.655c10.497-15.753,26.097-27.912,59.312-27.912c73.552,0,73.131,68.716,73.131,106.472
            L341.91,330.654L341.91,330.654z"/>
          </svg>
        </a>
        <a @click="accessShareLink('Twitter', twitter+home+viewUrl)">
          <svg id="Layer_1" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
          width="55" height="55" viewBox="0 0 1668.56 1221.19" style="enable-background:new 0 0 1668.56 1221.19; margin-right: 10px;" xml:space="preserve">
          <g id="layer1" transform="translate(52.390088,-25.058597)">
            <path id="path1009" d="M283.94,167.31l386.39,516.64L281.5,1104h87.51l340.42-367.76L984.48,1104h297.8L874.15,558.3l361.92-390.99
              h-87.51l-313.51,338.7l-253.31-338.7H283.94z M412.63,231.77h136.81l604.13,807.76h-136.81L412.63,231.77z"/>
          </g>
          </svg>
        </a>
        <a @click="accessShareLink('Email', email+home+viewUrl)">
          <svg id="Layer_1" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
          width="45" height="45" viewBox="0 0 128 128" style="enable-background:new 0 0 128 128;" xml:space="preserve">
            <circle style="fill:#267CB5;" cx="64" cy="64" r="64"/>
            <path style="fill:#FFFFFF;" d="M64,28"/>
            <path style="fill:#FFFFFF;" d="M64,72.4l38.2-32.7c-0.6-0.4-1.4-0.7-2.2-0.7H28c-0.8,0-1.6,0.3-2.2,0.7L64,72.4z"/>
            <path style="fill:#FFFFFF;" d="M66.6,75.4c-1.5,1.3-3.7,1.3-5.2,0L24,43.5V85c0,2.2,1.8,4,4,4h72c2.2,0,4-1.8,4-4V43.4L66.6,75.4z"/>
          </svg>
        </a>
      </div>
      <div class="form-control align-items-center sharing">
        <span class="url-field">{{ home + '/...' }}</span>
        <div style="float: right;">
          <span class="btn btn-primary btn-sm text-white copy-btn" @click.prevent="copyUrl('url2')">
            <span>{{ $t('Invite.copy').toUpperCase() }}</span>
          </span>
        </div>
        <input id="url2" data-test="url2" :value="home+viewUrl" type="hidden">
      </div>
      <span id="copied2" style="display: none;">{{ $t('Invite.copied') }}</span>
    </b-modal>
    <b-modal :id="'calendarLinks' + null" v-model="showCalendarLinks" hide-footer hide-header no-stacking>
      <div v-if="occurrence">
        <span>You can add this single event to your calendar, or all recurring events for this meeting. Choose from below:</span>
        <div class="row mt-3">
          <div class="col-md-12 px-3" style="display: flex; justify-content: space-evenly;">
            <div class="form-check">
              <label class="form-check-label fs-6">
                <input
                  id="chosen_event_single"
                  v-model="chosenEvent"
                  data-test="chosen_event_single"
                  name="chosenEvent"
                  type="radio"
                  value="single"
                  class="form-check-input"
                  style="width: 1.5em; height: 1.5em ;"
                  :checked="chosenEvent === 'single'"
                />
                <span style="vertical-align: sub; margin-left: 10px;">This event</span>
              </label>
            </div>
            <div class="form-check">
              <label class="form-check-label fs-6">
                <input
                  id="chosen_event_recurrent"
                  v-model="chosenEvent" 
                  data-test="chosen_event_recurrent"
                  name="chosenEvent"
                  type="radio"
                  value="recurrent"
                  class="form-check-input"
                  style="width: 1.5em ; height: 1.5em ;"
                  :checked="chosenEvent === 'recurrent'"
                />
                <span style="vertical-align: sub; margin-left: 10px;">All events</span>
              </label>
            </div>
          </div>
        </div>
        <hr style="background: repeating-linear-gradient(239deg, transparent, transparent 10px, black 10px, black 20px);margin: 20px 0px;" />
      </div>
      <span v-if="occurrence">
        Select the calendar you would like to add the event to:
      </span>
      <span v-else>
        Select the calendar you would like to add this event to:
      </span>
      <v-select
        id="chosen_calendar"
        v-model="chosenCalendar"
        data-test="chosen_calendar"
        :options="calendarOptions"
        label="name"
        class="my-3"
      >
      </v-select>
      <div class="text-center mt-2">
        <button id="add_to_calendar_modal" data-test="add_to_calendar_modal" class="btn btn-primary btn-sm pe-4 ps-4" :disabled="isCalendarButtonDisabled" @click="gotoCalendar">
          Add to Calendar
        </button>
      </div>
    </b-modal>
  </tr>
</template>
<script>
import moment from 'moment';
import orderBy from 'lodash/orderBy';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
//import ConfirmModalWithInput from '@/components/commons/Modals/ConfirmModalWithInput.vue';

export default {
  components: {
    vSelect,
  },
  props: {
    network: {
      type: Object,
      default: null,
    },
    meeting: {
      type: Object,
      default: null,
    },
    currentMeetingView: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      showOccurrences: false,
      showShareLinks: false,
      showShareOccurrenceLinks: false,
      showCalendarLinks: false,
      chosenEvent: 'single',
      chosenCalendar: '',
      calendarOptions: [
        {
          value: 'Google',
          name: this.$t('google-calendar'),
        },
        {
          value: 'Yahoo',
          name: this.$t('yahoo-calendar'),
        },
        {
          value: 'Outlook',
          name: this.$t('outlook-calendar'),
        },
        {
          value: 'ICS',
          name: this.$t('calendar-invite'),
        },
      ],
      occurrence: '',
      occurrenceID: '',
      home: window.location.origin,
      facebook: 'https://www.facebook.com/share.php?u=',
      whatsapp: 'https://wa.me/?text=',
      linkedin: 'https://www.linkedin.com/sharing/share-offsite/?url=',
      twitter: 'https://twitter.com/share?ref_src=twsrc%5Etfw&url=',
      email: 'mailto:?subject=Resonance meeting&amp;body=Check out this meeting ',
      confirmModal: {
        show: false,
      },
      today: moment(new Date()).format(),
      lastOccurrence: '',
      user_id: this.$store.getters['user'] ? this.$store.getters['user']['user_id'] : null,
    }
  },
  computed: {
    viewUrl() {
      let url = '/networks/' + this.network.slug + '/meetings/' + this.meeting.id;
      return url;
    },
    isCalendarButtonDisabled(){
      return !(this.chosenCalendar);
    },
  },
  mounted() {
    this.checkLastOccurrence();
  },
  methods: {
    checkLastOccurrence() {
      if (this.meeting.occurrences && this.meeting.occurrences.length !== 0) {
        const now = new Date();

        // filter occurrences that start after the current time
        const futureOccurrences = this.meeting.occurrences.filter((occurrence) => {
          const occurrenceStart = new Date(this.utcToLocal(occurrence.start));
          return occurrenceStart > now;
        });

        // count occurrences in progress (end time is after the current time)
        const occurrencesInProgress = futureOccurrences.filter((occurrence) => {
          const occurrenceStart = new Date(this.utcToLocal(occurrence.start));
          const occurrenceEnd = new Date(occurrenceStart.getTime() + occurrence.duration * 60000);
          return occurrenceEnd > now;
        }).length;

        // count of occurrences after the current time excluding those in progress
        const remainingOccurrences = futureOccurrences.length - occurrencesInProgress;

        // check if there is exactly one remaining occurrence
        this.lastOccurrence = remainingOccurrences === 1;
      }
    },
    utcToLocal: function (dt) {
      return moment.utc(dt).local();
    },
    sortedArray(array, order) {
      return orderBy(array, 'start', order);
    },
    sendInfo(item, type) {
      this.occurrence = '?occurrence=' + item;
      this.occurrenceID = item;
      if (type == 'occurrence') {
        this.showShareOccurrenceLinks = true;
      } else {
        this.showCalendarLinks = true;
      }
    },
    accessShareLink(link_name, link) {
      if (window.umami && typeof window.umami.track === 'function') {
        if (this.meeting.occurrence_id) {
          window.umami.track(`share-${link_name.toLowerCase()}-occurrence-${this.meeting.occurrence_id}`);
        } else {
          window.umami.track(`share-${link_name.toLowerCase()}-meeting-${this.meeting.id}`);
        }
      }
      const userId = this.user_id !== null ? this.user_id : 'null';
      const occurrenceId = this.occurrenceID !== '' ? this.occurrenceID : 'null';
      let url = `meetings/share/${this.meeting.id}/${occurrenceId}/${userId}/${link_name}`;
      this.$http.post(url).then(() => {
        window.location.href = link;
      });
    },
    extendMeeting(){
      this.$router.push({ 
        name: 'update-network-meeting-page',
        params: { id: this.meeting.id,
          isExtended: true,
          isPastOccurrence: this.currentMeetingView === 'past' ? true : false,
          startTime: this.meeting.start
        }
      });
    },
    liveMeeting(){
      let today = moment(new Date()).format('DD/MM/YYYY HH:mm:ss');
      let meetingDate = this.utcToLocal(this.meeting.start).format('DD/MM/YYYY HH:mm:ss');
      let ms = moment(meetingDate,"DD/MM/YYYY HH:mm:ss").diff(moment(today,"DD/MM/YYYY HH:mm:ss"));
      let d = moment.duration(ms);
      let months = d._data.months;
      let days = d._data.days;
      let hours = d._data.hours;
      let minutes = d._data.minutes;
      if (months == 0 && days == 0 && hours == 0) {
        if(minutes <= 0 && Math.abs(minutes) <= this.meeting.duration){
          return true;
        }
      } else {
        return false;
      }
    },
    copyUrl (value) {
      if (value == 'url1') {
        let urlToCopy = document.querySelector('#url1')
        urlToCopy.setAttribute('type', 'text')
        urlToCopy.select()

        document.getElementById("copied1").style.display = "inline";
        document.execCommand("copy");
        setTimeout( function() {
            document.getElementById("copied1").style.display = "none";
        }, 1000);

        /* unselect the range */
        urlToCopy.setAttribute('type', 'hidden')
        window.getSelection().removeAllRanges()
      } else if (value == 'url2') {
        let urlToCopy = document.querySelector('#url2')
        urlToCopy.setAttribute('type', 'text')
        urlToCopy.select()

        document.getElementById("copied2").style.display = "inline";
        document.execCommand("copy");
        setTimeout( function() {
            document.getElementById("copied2").style.display = "none";
        }, 1000);

        /* unselect the range */
        urlToCopy.setAttribute('type', 'hidden')
        window.getSelection().removeAllRanges()
      } else {
        let urlToCopy = document.querySelector('#zoom_url')
        urlToCopy.setAttribute('type', 'text')
        urlToCopy.select()

        document.getElementById("zoom_copied").style.display = "inline";
        document.execCommand("copy");
        setTimeout( function() {
            document.getElementById("zoom_copied").style.display = "none";
        }, 1000);

        /* unselect the range */
        urlToCopy.setAttribute('type', 'hidden')
        window.getSelection().removeAllRanges()
      }
    },
    downloadCalendarFile(data, name = this.meeting.title+'.ics') {
      var link = document.createElement('a');
      link.download = name;
      link.href = data;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    gotoCalendar () {
      let url = 'meetings/calendar/' + this.meeting.id;
      url += this.chosenEvent == 'single' ? `/${this.meeting.occurrence_id}/${this.user_id ? this.user_id : 'null'}/${this.chosenCalendar.value}` : `/${null}/${this.user_id ? this.user_id : 'null'}/${this.chosenCalendar.value}`;
      this.$http.post(url);
      if (this.chosenEvent == 'single') {
        // for single events we just need to remove the part in the url where the recurrent data is stored
        let indexGoogle = this.meeting.calendar_links.google.indexOf("&recur=RRULE:FREQ=");
        let indexYahoo = this.meeting.calendar_links.yahoo.indexOf("&repeat=1&interval=");
        let indexOutlook = this.meeting.calendar_links.outlook.indexOf("RRULE:FREQ=");
        switch (this.chosenCalendar.value) {
          case 'Google':
            window.open(this.meeting.calendar_links.google.slice(0, indexGoogle), "_blank");
            break;
          case 'Yahoo':
            window.open(this.meeting.calendar_links.yahoo.slice(0, indexYahoo), "_blank");
            break;
          case 'Outlook':
            window.open(this.meeting.calendar_links.outlook.slice(0, indexOutlook), "_blank");
            break;
          case 'ICS':
            this.downloadCalendarFile(this.meeting.calendar_links.ics_single);
            break;
        }
      } else {
        switch (this.chosenCalendar.value) {
          case 'Google':
            window.open(this.meeting.calendar_links.google_recurring, "_blank");
            break;
          case 'Yahoo':
            window.open(this.meeting.calendar_links.yahoo_recurring, "_blank");
            break;
          case 'Outlook':
            window.open(this.meeting.calendar_links.outlook_recurring, "_blank");
            break;
          case 'ICS':
            this.downloadCalendarFile(this.meeting.calendar_links.ics_recurring);
            break;
        }
      }
    },
  },
};
</script>
<style scoped>
tr {
  border-bottom-color: #b9b9d6;
}
.meeting td {
  width: 150px;
  text-align: center;
}
.sharing {
  margin-top: 28px;
  background: #D9D9D9;
  padding-right: 9px;
  padding-bottom: 11px;
}
.zoom-sharing {
  margin-top: 5px;
  background: #D9D9D9;
  padding-right: 9px;
  padding-bottom: 11px;
}
.url-field {
  line-height: 24px;
  font-weight: 400;
  text-align: left;
  color: #005F9A;
  font-size: 15px;
  user-select: none;
}
.copy-btn {
  display: flex;
  padding: 5px 20px;
}
.copy-btn span {
  font-size: 10px;
  font-weight: 400;
}
#copied1, #copied2, #zoom_copied {
  font-size: 14px;
  color: red;
  display: none;
}
.modal-footer button.btn.btn-primary {
  color: #fff;
  background-color: #dc3545;
  border-color: #dc3545;
}
.custom-border {
  border: 2px solid;
}
</style>
